// src/components/home/EdgeJetson.js
// Dark section: edge/on-premise architecture and the NVIDIA Jetson platform.
import React from 'react';
import { useTranslation } from 'react-i18next';

const Check = () => (
    <svg className="w-5 h-5 text-accent flex-shrink-0 mt-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
    </svg>
);

const EdgeJetson = () => {
    const { t } = useTranslation();
    const edgePoints = t('home.edge.points', { returnObjects: true }) || [];
    const jetsonPoints = t('home.jetson.points', { returnObjects: true }) || [];

    return (
        <div className="bg-slate-900 relative overflow-hidden py-16">
            <div className="absolute top-0 right-0 w-96 h-96 bg-primary opacity-10 rounded-full blur-3xl pointer-events-none" aria-hidden="true"></div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                <div className="grid lg:grid-cols-2 gap-12">
                    {/* Edge & on-premise */}
                    <div data-aos="fade-right">
                        <h2 className="text-3xl font-bold text-white mb-4">{t('home.edge.title')}</h2>
                        <div className="w-24 border-b-4 border-accent mb-6"></div>
                        <p className="text-gray-300 mb-4 text-justify">{t('home.edge.p1')}</p>
                        <p className="text-gray-300 mb-6 text-justify">{t('home.edge.p2')}</p>
                        <ul className="space-y-3">
                            {Array.isArray(edgePoints) && edgePoints.map((point, i) => (
                                <li key={i} className="flex items-start text-gray-200">
                                    <Check />
                                    <span className="ml-3">{point}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* NVIDIA Jetson */}
                    <div data-aos="fade-left" data-aos-delay="200">
                        <h2 className="text-3xl font-bold text-white mb-4">{t('home.jetson.title')}</h2>
                        <div className="w-24 border-b-4 border-accent mb-6"></div>
                        <p className="text-gray-300 mb-6 text-justify">{t('home.jetson.p1')}</p>
                        <ul className="space-y-3">
                            {Array.isArray(jetsonPoints) && jetsonPoints.map((point, i) => (
                                <li key={i} className="flex items-start text-gray-200">
                                    <Check />
                                    <span className="ml-3">{point}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EdgeJetson;
